import { render } from "./S354041.vue?vue&type=template&id=14b04363"
const script = {}
script.render = render

export default script